export const USER_INFO = "user_info";
export const JWT_TOKEN = process.env.REACT_APP_TOKEN_KEY as string;
export const REFRESH_TOKEN = process.env.REACT_APP_REF_TOKEN_KEY as string;

export const AUTH_BASE_URL = process.env.REACT_APP_AUTH_URL as string;
export const AUTH_LOGIN_URL = `${AUTH_BASE_URL}/login`;
export const AUTH_LOGOUT_URL = `${AUTH_BASE_URL}/logout`;

// Build the portal login URL with a `redirect` param pointing back to the page
// the user is currently on, so the portal can return them here after login.
// Uses the full current URL (including path + query) so deep links are preserved.
export function getLoginUrlWithRedirect(): string {
  const returnUrl = window.location.href;
  return `${AUTH_LOGIN_URL}?redirect=${encodeURIComponent(returnUrl)}`;
}
